export const transformNullToString = (value: string | null) => (value === null ? '' : value)
